import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails, { AccordionDetailsProps } from "@mui/material/AccordionDetails";

interface IAircraftTitleProps {
  title: string;
  icon: JSX.Element | null;
}

export const Accordion: React.FC<AccordionProps> = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

export const AccordionDetails: React.FC<AccordionDetailsProps> = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export function AircraftTitleHeader(props: IAircraftTitleProps): JSX.Element {
  const aircraftTitleStyles = {
    padding: "6px 12px",
    fontWeight: 900,
    fontSize: "1.1em",
    backgroundColor: "#172331",
    display: "flex",
    justifyContent: "space-between",
  };
  return (
    <Box sx={aircraftTitleStyles}>
      {props.title}
      {props.icon}
    </Box>
  );
}

export const ConfigurationItem: React.FC<AccordionSummaryProps> = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
  backgroundColor: "#536476",
  flexDirection: "row-reverse",
  padding: "0px 16px",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    margin: "0px 4px",
  },
}));

export const RevisionHeader: React.FC<BoxProps> = styled(Box)(({ theme }) => ({
  backgroundColor: "#0A1017",
  fontWeight: 900,
  lineHeight: 1,
  display: "flex",
  justifyContent: "space-between",
  padding: "4px 14px 4px 20px",
}));

export const RevisionItem: React.FC<BoxProps> = styled(Box)(({ theme }) => ({
  backgroundColor: "#233D58",
  padding: theme.spacing(1),
  borderTop: "1px solid #0A1017",
  paddingLeft: theme.spacing(4),
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  paddingRight: "14px",
}));
